<template>
  <div
    :id="`${namespace}_floating_hints_opener`"
    class="clr-grey mdi mdi-lightbulb hintsmenu_opener icon_btn csst"
  >
    <!-- @mouseenter="(e) => fl_positionTooltip(e, { placement: 'right-start' })" -->
    <div
      class="csst_content text-nowrap clr-white"
      style="top: calc(100% + 0.25rem); transform: translate(-0.25rem, 0)"
      v-html="$t('tooltips.table_hints_menu')"
    ></div>
    <!-- style="position: fixed" -->
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TrainerHintsFloatOpener',
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
  },
}
</script>
<style lang="scss" scoped>
.hintsmenu {
  &_opener {
    text-shadow: var(--text-shadow_outlined);
    font-size: 1.25rem;
    height: 2rem;
    width: 2rem;
  }
}
</style>
